enum EDraftName {
  ACCOUNT_ACTIVATE= 'account_activate'
}

export default EDraftName;
